var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useMemo, useCallback, useContext, useEffect, useState, useRef } from 'react';
import { ProstoreSsrContext } from './ProstoreSsrContext';
import { checkRequestState } from '@proscom/prostore';
import { useConnectStore } from './useConnectStore';
import { useContextStore } from './ProstoreContext';
/**
 * Хук, подключающий компонент к стору и запрашивающий данные
 * в соответствии с variables
 */
export function useRequestStore(storeOrName, variables, options) {
    if (options === void 0) { options = null; }
    // Подключаем стор из контекста
    var store = useContextStore(storeOrName);
    // Подключение к контексту, который хранит все результаты
    var ssrContext = useContext(ProstoreSsrContext);
    // Фейковое состояние для ререндера
    var _a = useState(0), rerender = _a[1];
    // Локальная копия состояния стора
    var stateRef = useRef(null);
    // Ссылка на текущий стор
    var storeRef = useRef(null);
    // Если стор изменился
    if (store !== storeRef.current) {
        // Запоминаем текущий стор
        storeRef.current = store;
        // Если в контексте есть значение, используем его
        stateRef.current = store.getValueFromContext(ssrContext);
    }
    // Колбек для обновления состояния
    var setState = useCallback(function (newState) {
        if (stateRef.current !== newState) {
            stateRef.current = newState;
            rerender(function (s) { return s + 1; });
        }
    }, []);
    // Подписываемся на изменения стора
    useConnectStore(store, setState);
    // Локальная копия состояния стора
    var state = stateRef.current;
    // Проверка, нужно ли запрашивать данные
    var queryCheck = checkRequestState(state, variables);
    // Мемоизированный колбек для загрузки данных
    var loadData = useCallback(function () {
        return store
            .loadData(variables, __assign({ ssr: ssrContext && ssrContext.isServer }, options))
            .then(function () {
            store.setContextValue(ssrContext);
        });
    }, [store, variables, options]);
    // Запрос данных, если он нужен
    useEffect(function () {
        if (queryCheck.request) {
            // Вероятность ошибки в этом месте мала, т.к.
            // основные ошибки обрабатываются в RequestStore
            // Поэтому мы ее просто залогируем
            loadData().catch(function (e) { return console.error(e); });
        }
    });
    // Если мы сейчас в режиме серверного рендеринга, то запрашиваем данные
    if (ssrContext && ssrContext.isServer && queryCheck.request && store.ssrId) {
        ssrContext.registerPromise(loadData());
    }
    // Возвращаем то, что может быть полезно в самом компоненте
    return { check: queryCheck, state: state, load: loadData };
}
export function useRequestStoreVars(storeOrName, variableCreator, args) {
    var variables = useMemo(variableCreator, args);
    return useRequestStore(storeOrName, variables);
}
//# sourceMappingURL=useRequestStore.js.map